"use client";

import { useEffect } from "react";

import { type TrackingEvent } from "@/globals";

async function hash(message: string | undefined): Promise<string> {
    if (!message) {
        return "";
    }

    const encoder = new TextEncoder();
    const data = encoder.encode(message);

    const hashArray = Array.from(
        new Uint8Array(await window.crypto.subtle.digest("SHA-256", data)),
    );
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export const fireFormEvent = async (
    event: "contact_form" | "register" | "download" | "hr_form" | "cancel_form",
    etype: string,
    email: string | undefined,
) => {
    const hashedMail = await hash(email);

    fireTrackingEvent({
        event: event,
        etype: etype,
        enhanced_conversion_data: {
            email: hashedMail,
        },
        customProperties: {
            Target: [event, etype, "1", "a"],
        },
    });
};

export const fireTrackingEvent = (data: TrackingEvent) => {
    try {
        const win = window as unknown as { dataLayer: TrackingEvent[] };
        win.dataLayer = win.dataLayer || [];
        win.dataLayer.push(data);
    } catch (error) {
        console.error(error);
    }
};

let lastEvent = "";

export const Tracking = (props: { data: TrackingEvent }) => {
    useEffect(() => {
        // this prevents sending the same event twice
        if (lastEvent === JSON.stringify(props.data)) {
            return;
        }
        fireTrackingEvent(props.data);
        lastEvent = JSON.stringify(props.data);
    }, [props.data]);
    return null;
};
